module.exports = __webpack_public_path__ + "static/media/roboto-greek-ext-400-normal.182ee6a4.woff2";